export interface UpdateReserveToPreparationRequest {
  id: number
}

export function UpdateReserveToPreparationRequestToJSON(
  value: UpdateReserveToPreparationRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined
  }
}
